import React from "react";
import { Tabs, Tab } from '@mui/material';

const Footer = ({ defaultOption = 0, options, onOptionSelected, backgroundColor = '#F6EDE1' }) => {
  const [value, setValue] = React.useState(defaultOption);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    onOptionSelected && onOptionSelected(newValue)
  };

  return (<>
    <Tabs
      value={value}
      onChange={handleChange}
      aria-label="icon position tabs example"
      variant="fullWidth" // Para que las pestañas ocupen todo el ancho
      sx={{ justifyContent: 'space-between', background: backgroundColor }}
      indicatorColor="secondary"
      textColor="secondary"
      // sx={{
      //   position: 'fixed',
      //   bottom: 0,
      //   width: '100%',
      //   backgroundColor: '#ffffff',
      //   boxShadow: '0 -2px 5px rgba(0, 0, 0, 0.1)'
      // }}
    >
    {options && options.map(({ tittle, icon, disabled, backgroundColor, colorFont }) => (
      <Tab key={tittle} label={tittle} icon={icon} disabled={disabled} sx={{background: backgroundColor, color: colorFont}}/>
    ))}
    </Tabs>
    
    </>)
}

export default Footer;